import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ServicioGastoService, MenuFuncionService, ServicioGrupoService, ComunidadService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, ServicioGasto, SaveServicioGastoDto, SearchServicioGrupoRequest, ServicioGrupo, DialogConfirmRequest, DialogConfirmResponse, ComunidadTiposGastos, LocalStorageKeys, SearchComunidadRequest, Comunidad, ExpensaTipoGastoComunidadServicioGasto, TipoGastoComunidadServicioGasto, TipoGasto } from '../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-servicioGastoEdit',
  templateUrl: './servicioGastoEdit.component.html',
  styles: [
  ]
})

export class ServicioGastoEditComponent implements OnInit {

  @ViewChild('tipoGastoServicioGrid')
  public tipoGastoServicioGrid: GridComponent;

  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  // isCategoriaGastoSearching: boolean = false;
  isServicioGrupoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isTipoGastoComunidadSearching: boolean = false;
  isComunidadTipoGastoServicioSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;

  msgError: string = "";
  item: ServicioGasto;
  itemTipoGasto: ExpensaTipoGastoComunidadServicioGasto;
  comunidadSeleccionada: Comunidad | null;
  tiposGastoSeleccionados: any[];

  // categoriaGastoList: CategoriaGasto[];
  comunidadList: Comunidad[];
  servicioGrupoList: ServicioGrupo[];
  comunidadTipoGastoList: ComunidadTiposGastos[];
  comunidadTipoGastoServicioList: any[];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private comunidadService: ComunidadService,
    // private categoriaGastoService: CategoriaGastoService,
    private servicioGrupoService: ServicioGrupoService,
    private servicioGastoService: ServicioGastoService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.SERVICIO_GASTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_DELETE);
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    if (this.canAdd || this.canEdit) {
      this.buildForm();
      // this.getCategoriasGastos();
      this.getGruposServicios();
      this.getComunidades();
    }

    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(200)]],
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      // 'CategoriaGastoId': [null, Validators.required],
      'ServicioGrupoId': [null, Validators.required],
      'Activo': [true, Validators.required]
    });
  }

  // getCategoriasGastos() {
  //   var r = new SearchCategoriaGastoRequest(null, null, true, "Nombre", null, null, true);
  //   this.isCategoriaGastoSearching = true;

  //   this.categoriaGastoService.search(r).subscribe(data => {
  //     this.isCategoriaGastoSearching = false;
  //     if (data != null)
  //       this.categoriaGastoList = data?.result;
  //   },
  //   (err: HttpErrorResponse) => {
  //     this.isCategoriaGastoSearching = false;
  //     this.sharedFunctions.handleError(err);
  //   });
  // }

  getGruposServicios() {
    var r = new SearchServicioGrupoRequest(null, null, true, "Nombre", null, null, true);
    this.isServicioGrupoSearching = true;

    this.servicioGrupoService.search(r).subscribe(data => {
      this.isServicioGrupoSearching = false;
      this.servicioGrupoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isServicioGrupoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
        cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  compareComunidades(o1: Comunidad, o2: Comunidad): boolean {
    return o1?.Id == o2?.Id;
  }

  compareTiposGasto(o1: TipoGasto, o2: TipoGasto): boolean {
    return o1?.Id == o2?.Id;
  }

  getTiposGastosByComunidad(comunidadId: number) {
    if (comunidadId == null || comunidadId <= 0)
      return false;

    this.isTipoGastoComunidadSearching = true;
    this.comunidadService.getTiposGasto(comunidadId).subscribe(data => {
      this.isTipoGastoComunidadSearching = false;
      this.comunidadTipoGastoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoGastoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
            if(this.canView || this.canEdit) {
              this.isSearching = true;
              this.servicioGastoService.get(id).subscribe(data => {
                this.isSearching = false;
                if (data != null && data.Success) {
                  this.item = data.Result;

                  if (this.item != null && this.item.Id > 0) {
                    this.getComunidadTiposGastosServicios();

                    if (this.canEdit)
                      this.formGroup.patchValue(this.item);
                  }
                  else
                    this.msgError = "No se encontró el item seleccionado.";
                }
                else
                  this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
              },
              (err: HttpErrorResponse) => {
                this.isSearching = false;
                this.sharedFunctions.handleError(err, true);
              })
           }
           else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        if (this.canAdd) {
          this.item = new ServicioGasto(0, null, null, null, null, true);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getComunidadTiposGastosServicios() {
    this.isComunidadTipoGastoServicioSearching = true;
    this.servicioGastoService.getTiposGastoServicios(this.item?.Id).subscribe(data => {
        this.isComunidadTipoGastoServicioSearching = false;
        var itemList = data?.Result;

        if (itemList != null && itemList.length > 0) {
            this.comunidadTipoGastoServicioList = itemList.reduce(function(rv: any[], item: TipoGastoComunidadServicioGasto) {
              var index = rv.findIndex(f => f.ComunidadId == item.ComunidadId);
              if (index < 0) {
                rv.push({ ComunidadId: item.ComunidadId, ComunidadNombre: item.ComunidadNombre, TiposGastos: [] });
                index = rv.length - 1;
              }

              rv[index].TiposGastos.push({ TipoGastoComunidadId: item.TipoGastoComunidadId, TipoGastoId: item.TipoGastoId, TipoGasto: item.TipoGasto });
              return rv;
            }, []);
        }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadTipoGastoServicioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  // getErrorCategoriaGastoId() {
  //   var v = this.formGroup.get('CategoriaGastoId');
  //   if (v?.hasError('required'))
  //     return 'El campo es obligatorio';
  //   return '';
  // }

  getErrorServicioGrupoId() {
    var v = this.formGroup.get('ServicioGrupoId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveServicioGastoDto(null, null, null, true);

    var allTiposGastos : number[] = [];
    if (this.comunidadTipoGastoServicioList != null && this.comunidadTipoGastoServicioList.length > 0) {
      for (var i=0; i<this.comunidadTipoGastoServicioList.length; i++) {
        if (this.comunidadTipoGastoServicioList[i].TiposGastos != null && this.comunidadTipoGastoServicioList[i].TiposGastos.length > 0) {
          for (var j=0; j<this.comunidadTipoGastoServicioList[i].TiposGastos.length; j++)
            allTiposGastos.push(this.comunidadTipoGastoServicioList[i].TiposGastos[j].TipoGastoComunidadId);
        }
      }
    }

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo,
        TiposGasto: allTiposGastos
      }
    };

    this.isSaving = true;
    this.servicioGastoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.servicioGastoService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onComunidadSelection() {
    this.comunidadTipoGastoList = [];
    if(this.comunidadSeleccionada !== null)
    this.getTiposGastosByComunidad(this.comunidadSeleccionada?.Id);
  }

  getTiposGastosConcat(selectedItem: any) {
    if (selectedItem != null && selectedItem.TiposGastos != null)
      return selectedItem?.TiposGastos?.map(item => item?.TipoGasto)?.join(", ");
    return "";
  }

  onTipoGastoServicioAdd() {

    if (this.comunidadSeleccionada == null || this.comunidadSeleccionada.Id == null || this.comunidadSeleccionada.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una comunidad para continuar", "Error");
      return false;
    }

    if (this.tiposGastoSeleccionados == null || this.tiposGastoSeleccionados.length <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar al menos un tipo de gasto para continuar", "Error");
      return false;
    }

    if (this.comunidadTipoGastoServicioList == null)
        this.comunidadTipoGastoServicioList = [];

    var index = this.comunidadTipoGastoServicioList.findIndex(f => f.ComunidadId == (this.comunidadSeleccionada?.Id));
    if (index < 0) {
        this.comunidadTipoGastoServicioList.push({ ComunidadId: this.comunidadSeleccionada.Id, ComunidadNombre: this.comunidadSeleccionada.Nombre, TiposGastos: [] });
        index = this.comunidadTipoGastoServicioList.length - 1;
    }

    for (var i=0; i<this.tiposGastoSeleccionados.length; i++)
      this.comunidadTipoGastoServicioList[index].TiposGastos.push({ TipoGastoComunidadId: this.tiposGastoSeleccionados[i].Id, TipoGastoId: this.tiposGastoSeleccionados[i].TipoGastoId, TipoGasto: this.tiposGastoSeleccionados[i].TipoGasto });

    this.tipoGastoServicioGrid.refresh();

    this.comunidadSeleccionada = null;
    this.tiposGastoSeleccionados = [];
    this.comunidadTipoGastoList = [];
  }

  onTipoGastoServicioDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.comunidadTipoGastoServicioList == null)
        this.comunidadTipoGastoServicioList = [];

      this.comunidadTipoGastoServicioList.splice(item.index, 1);
      this.tipoGastoServicioGrid.refresh();
    }
  }

  onCancel() {
    this.location.back();
  }
}
